// Restaurant settings of the website.
//
// AxelPOS edits them in Paramétrage > Site web (Firestore settings/web) and
// copies them into settings/publicMenu under "web". The site reads, field by
// field:
//   1. settings/publicMenu "web" (the same read as the menu, no extra cost)
//   2. settings/web (only when the POS has not published "web" yet)
//   3. src/clients.json (fallback until the restaurant is migrated)
//
// index.js calls loadSiteConfig() before it loads App, so every file can read
// the values at import time:  import site from "../siteConfig";  site.phone

import clients from "./clients.json";
import { loadPublished } from "./LandingPage/menuSource";

const local = clients.clients[clients.active];
if (!local) {
  throw new Error(
    `Unknown active client: "${clients.active}". ` +
    `Available: ${Object.keys(clients.clients).join(", ")}`
  );
}

// Build values that Firestore never replaces.
const BUILD_ONLY = ["firebaseConfig", "lsKey", "name", "mapsKey"];

const site = { ...local, mapsKey: clients.shared && clients.shared.mapsKey };

const TIMEOUT_MS = 5000;

function readWebDoc() {
  return window.firebase.firestore().collection("settings").doc("web").get()
    .then(snap => (snap.exists ? snap.data() : null))
    .catch(() => null);
}

async function readRemote() {
  const menu = await loadPublished();
  // "web" present: the POS published it (null: no settings/web yet, use clients.json).
  if (menu && "web" in menu) return menu.web && typeof menu.web === "object" ? menu.web : null;
  return readWebDoc();
}

function merge(remote) {
  if (remote) {
    for (const [k, v] of Object.entries(remote)) {
      if (BUILD_ONLY.includes(k) || v === undefined || v === null) continue;
      site[k] = v;
    }
  }
  // The customizer calls .includes() on these lists.
  if (site.extrasConfig) {
    const x = site.extrasConfig;
    site.extrasConfig = {
      ...x,
      categoriesWithExtras: Array.isArray(x.categoriesWithExtras) ? x.categoriesWithExtras : [],
      categoriesWithFreeDrink: Array.isArray(x.categoriesWithFreeDrink) ? x.categoriesWithFreeDrink : [],
    };
  }
}

let loading = null;

// Never rejects. After 5 s without an answer the site starts with clients.json.
export function loadSiteConfig() {
  if (!loading) {
    const timeout = new Promise(resolve => setTimeout(() => resolve(null), TIMEOUT_MS));
    loading = Promise.race([readRemote(), timeout])
      .then(merge)
      .catch(() => {});
  }
  return loading;
}

export default site;
